<template>
	<FormKit
		:name="section.type"
		type="repeater"
		:sections-schema
		:controls="false"
		:add-button="false"
	>
		<template #default="{ value, index }">
			<DashboardCardCollapsible :heading="section.getHeading(value.id)">
				<template #icons>
					<AppButton
						variant="ghost"
						type="button"
						icon="remove"
						class="text-sm"
						aria-label="Verwijderen"
						@click="$emit('remove', value.id)"
					/>
					<AppButton
						variant="ghost"
						type="button"
						icon="add"
						aria-label="Toevoegen"
						@click="$emit('insert', index)"
					/>
				</template>
				<FormKit type="group" name="values">
					<component :is="section.component" :entry="value"></component>
				</FormKit>
			</DashboardCardCollapsible>
		</template>
	</FormKit>
</template>

<script lang="ts" setup>
import type { Component } from "vue";

interface RepeatableSection {
	type: string;
	component: Component;
	getHeading: (id: string) => string;
}

interface Props {
	section: RepeatableSection;
}

defineProps<Props>();

defineEmits<{
	remove: [id: string];
	insert: [index: number];
}>();

const sectionsSchema = {
	items: { attrs: { class: "" } },
	item: { attrs: { class: "mb-4" } },
	content: { attrs: { class: "" } },
	controls: { attrs: { class: "" }, children: [] as any[] },
	outer: { attrs: { class: "" } },
};
</script>
